module.exports = __webpack_public_path__ + "img/anker.42d65e00.svg";